module.exports = __webpack_public_path__ + "static/media/nav-contact.e9a552d8.svg";